import { BellRing, FileDown, MailCheck, RotateCw, ShieldCheck, TriangleAlert, Upload } from "lucide-react";

const eventIcons = { document_downloaded: FileDown, document_uploaded: Upload, email_acknowledgement: MailCheck, email_notification: MailCheck, email_unavailable: TriangleAlert, access_approved: ShieldCheck, access_declined: ShieldCheck };

function formatEventTime(timestamp) {
  return new Date(timestamp).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export default function ActivityEventList({ items, onResend, resendingEntity }) {
  if (!items.length) return <div className="empty-state" data-testid="activity-feed-empty-state">No activity matches the selected filters.</div>;
  return <div className="activity-feed" data-testid="admin-activity-feed">
    {items.map((item) => {
      const Icon = eventIcons[item.activity_type] || BellRing;
      const canResend = item.activity_type.startsWith("email_") && item.entity_id;
      return <article className={`activity-item activity-item--${item.status}`} id={`activity-event-${item.activity_id}`} key={item.activity_id} data-testid={`activity-event-${item.activity_id}`}>
        <Icon size={18} />
        <div><h3>{item.title}</h3><p>{item.description}</p></div>
        <div className="activity-item-actions"><time dateTime={item.created_at}>{formatEventTime(item.created_at)}</time>{canResend && <button className="icon-button" type="button" title="Resend submission emails" disabled={resendingEntity === item.entity_id} onClick={() => onResend(item.entity_id)} data-testid={`resend-email-${item.entity_id}`}><RotateCw size={14} /></button>}</div>
      </article>;
    })}
  </div>;
}